/* jshint esversion: 6, -W097 */
/* globals module */
"use strict";

/*
    Creates a new controller for the flat pages called "FlatPageCtrl"
*/
FlatPageCtrl.$inject = [
    '$sce',
    '$timeout',
    '$location',
    'flatPageData',
    'AnalyticsService',
    'CmsContentService',
    'SolarService',
    'TemplateService',
    'UtilService',
];
function FlatPageCtrl(
    $sce,
    $timeout,
    $location,
    flatPageData,
    AnalyticsService,
    CmsContentService,
    SolarService,
    TemplateService,
    UtilService
) {
    const vm = this;
    vm.siteTitle = UtilService.getSiteSetting('title');
    vm.pageTitle = TemplateService.render(
        flatPageData.title,
        UtilService.getSiteSetting('flatpage_context', {})
    );
    vm.openSolarWidget = (shouldShowDisclosure=true, projectType=_pub.PROJECT_TYPE_SOLAR) => {
        AnalyticsService.reportEvent('Promo Clicked', {
            type: projectType.replace('_', ' '),
            location: 'flat page'
        });
        SolarService.openSolarWidget(shouldShowDisclosure, projectType);
    };

    if (flatPageData.head.length > 0) {
        //get raw html value from cms page data
        vm.head = flatPageData.head[0].value.replace(/<meta/g, "<update-meta");
        vm.head = vm.head.replace(/<title/g, "<update-title");
    } else if (flatPageData.meta) {
        // update meta tags as specified in wagtail content
        vm.metaTitle = flatPageData.meta.seo_title;
        vm.metaDescription = flatPageData.meta.search_description;
    } else {
        vm.metaTitle = vm.siteTitle + ' - ' + vm.pageTitle;
        //get default value from CMS for site
        CmsContentService.getMarketPlaceText('base:meta:head').then(function (text) {
            vm.head = text.replace(/&lt;meta/g, "<update-meta").replace(/&gt;/g, ">");
       });
    }


    vm.body = flatPageData.body;
    vm.body.forEach(function (content_piece) {
        // render any template content
        content_piece.value = TemplateService.render(
            content_piece.value,
            UtilService.getSiteSetting('flatpage_context', {})
        );
        // we need to make sure that the content is trusted or else Angular is gonna freak out.
        if (content_piece.type === 'paragraph') {
            content_piece.value = $sce.trustAsHtml(content_piece.value);
        }
    });

    const section = $location.search().section;
    $timeout(() => {
        if (section) {
            UtilService.goToSection(section);
        }
    }, 200);
}

module.exports = FlatPageCtrl;
